//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sortBy, maxBy } from 'lodash-es';
import Feature from '~/components/feature';
import PriceRange from '~/components/price-range';
import textLength from '~/utils/feature-text-length';
import fractionToDecimal from '~/utils/fraction-to-decimal';
export default {
  components: {
    Feature,
    PriceRange,
  },
  async asyncData({ $content }) {
    const items = sortBy(
      (await $content('services').fetch())
        .filter((item) => !item.deleted_at)
        .map((item) => ({
          ...item,
          pos: fractionToDecimal(item.pos),
        })),
      [
        'pos',
        /**
         * Sort by largest price
         * @param {*} o item to sort
         */
        function (o) {
          const plans = sortBy(o?.plans ?? { free: { price: 0 } }, 'price');
          const max = maxBy(plans, 'price');
          return max.price;
        },
        textLength,
        'slug',
      ],
    ).reverse();
    return { items };
  },
  data() {
    return {
      heading: 'Services',
      description:
        'We offer a range of services to help you get the most out of your website.',
      items: [],
      defaultPlan: { unset: { price: 0 } },
    };
  },
  head() {
    return {
      title: this.heading,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
      ],
    };
  },
};
